import React from 'react';

export interface DrinkElementProps {
    element?: string;
    price?: string
    description?: string;
}

function DrinkElement(props: DrinkElementProps) {
    return (
        <div className='mt-4'>

            <div className='flex-between-center '>

                <div className='dish-title '>
                    {props.element}
                </div>
                <div className='dish-price'>
                    {props.price}€
                </div>
            </div>
            <div className='flex-start-center'>

                <div className='dish-description'>
                    {props.description}
                </div>
            </div>
        </div>
    );
}

export default DrinkElement;